export { DatabaseSdk, type DatabaseSdkOptions } from './sdk/database-sdk.ts';
export { FieldSdk } from './sdk/field-sdk.ts';
export { EntrySdk } from './sdk/entry-sdk.ts';
export { ValueSdk } from './sdk/value-sdk.ts';
export { ViewSdk, type ViewSdkOptions } from './sdk/view-sdk.ts';
export { MetaSdk } from './sdk/meta-sdk.ts';
export type { SetLockedInput } from './domain/meta/schemas/locked.ts';
export type {
  ViewLayoutWritePolicy,
  ViewLayoutWritePolicyError,
  ViewLayoutWritePolicyErrorReason
} from './sdk/views/view-layout-write-policy.ts';
export { builtInOnlyWritePolicy } from './sdk/views/view-layout-write-policy.ts';

// fallow-ignore-next-line unused-export -- Public SDK validator used by external consumers.
export { createEntryValueValidator } from './domain/entries/validators.ts';

// fallow-ignore-next-line unused-type -- public convenience re-export for external SDK callers
export type { CellAddress } from '@databases/sdk-types';
export type {
  DatabaseSdkContract,
  FieldSdkContract,
  EntrySdkContract,
  ValueSdkContract,
  ViewSdkContract,
  MetaSdkContract,
  CreateEntryFieldError,
  SdkError,
  StateErrorReason,
  DatabaseMetaSnapshot
} from '@databases/sdk-types';

// fallow-ignore-next-line unused-type -- Public SDK input contract used by external consumers.
export type { CreateEntryDatabaseValue } from '@databases/sdk-types';

// fallow-ignore-next-line unused-type -- Public SDK input contract used by external consumers.
export type { CreateEntrySelectValue } from '@databases/sdk-types';

// fallow-ignore-next-line unused-type -- Public SDK result contract used by external consumers.
export type { CreateEntryResult } from '@databases/sdk-types';

export type {
  DatabaseField,
  DatabaseEntry,
  DatabaseValue,
  DatabaseView,
  DatabaseFieldType
} from './types.ts';
